import { each, isEmpty } from 'lodash'

export const addFilters = (filters, ...fields) => {
  each(fields, config => {
    const [field, value] = config
    if (!isEmpty(value)) {
      return (filters[field] = value)
    }

    delete filters[field]
  })

  return filters
}
